module.exports = __webpack_public_path__ + "static/media/20.f993681b.mp3";